/**
 * @module alias
 * @private
 * @since 2.0.0
 */

/**
 * Check if a function exist on the global Fiverr object
 * @param  {String} name The function name
 * @return {Boolean}
 */
const available = (name) => typeof Fiverr === 'object' && typeof Fiverr[name] === 'function' ? true : undefined; // eslint-disable-line no-undef

/**
 * Creates a "safe" alias for a Fiverr function
 * @param  {string} name Function name
 * @return {Function}
 */
export const alias = (name) => (...args) => available(name) && Fiverr[name](...args); // eslint-disable-line no-undef
